var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"discover-tabs"},_vm._l((_vm.tabs),function(name,key){return _c('div',{staticClass:"discover-tabs-tab",class:{'active' : _vm.filterType === key},on:{"click":function($event){return _vm.setMode(key)}}},[_c('span',[_vm._v(_vm._s(_vm.trans(name)))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }